// extracted by mini-css-extract-plugin
export var divider = "_uz-0";